<div class="table-responsive">
    <table class="table table-sm">
        <thead>
            <tr>
                <th
                    app-sortable-table-header
                    [column]="'propertyNo'"
                    (sort)="onSort($event)"
                    [label]="'common_apartment' | translate: 'online' : 'ngonline'"></th>
                <th>
                    {{ 'properties_residentName' | translate: 'online' : 'systems' }}
                </th>
                <th>
                    {{ 'properties_email' | translate: 'online' : 'residents' }}
                </th>
                <th>
                    {{ 'common_PHONE' | translate: 'online' : 'common' }}
                </th>
                <th>
                    {{ 'properties_dateOfOccupation' | translate: 'online' : 'systems' }}
                </th>
                <th>
                    {{ 'properties_dateOfRelocation' | translate: 'online' : 'systems' }}
                </th>
                @if (showOnlineAccess()) {
                    <th class="text-center">
                        {{ 'actions_residentAccess' | translate: 'online' : 'residents' }}
                    </th>
                }
                <th></th>
            </tr>
            <tr class="bg-light">
                <ng-content select="[filter-row-content]"></ng-content>
            </tr>
        </thead>
        <tbody class="text-nowrap">
            @for (row of preparedRows(); track $index) {
                <tr
                    class="align-middle"
                    [class.striped]="row.striped"
                    [class.is-current]="row.kind === 'current'"
                    [class.history-row]="row.kind === 'history'">
                    @if (row.isFirstInLocation) {
                        <td class="location-cell" [attr.rowspan]="row.locationRowspan">
                            <div>{{ row.proBraLoc }}</div>
                            <div class="text-muted small">
                                <app-address
                                    [country]="row.location.countryCode ?? ''"
                                    [floor]="row.location.floor ?? ''"
                                    [stairway]="row.location.stairway ?? ''"
                                    [street]="row.location.street ?? ''" />
                            </div>
                        </td>
                    }
                    <td>{{ row.consumer?.name }}</td>
                    <td>{{ row.consumer?.email }}</td>
                    <td>{{ row.consumer?.phoneNumber }}</td>
                    <td>{{ row.consumer?.occupationDate | appdate }}</td>
                    <td>{{ row.consumer?.occupationEndDate | appdate }}</td>
                    @if (showOnlineAccess()) {
                        <td class="text-center">
                            <app-true-false [value]="row.consumer?.onlineAccess === 'ACTIVE'" />
                        </td>
                    }
                    <td class="text-end">
                        @if (row.consumer?.consumerId) {
                            <div ngbDropdown placement="bottom-end" container="body">
                                <button
                                    class="btn btn-link btn-sm"
                                    ngbDropdownToggle
                                    (click)="$event.stopPropagation()">
                                    <i class="bi bi-three-dots-vertical"></i>
                                </button>
                                <div ngbDropdownMenu>
                                    <a
                                        ngbDropdownItem
                                        [routerLink]="[
                                            row.location.locationId,
                                            'resident',
                                            row.consumer?.consumerId,
                                        ]">
                                        {{
                                            'titles_residentDetails'
                                                | translate: 'online' : 'residents'
                                        }}
                                    </a>
                                    <button
                                        type="button"
                                        ngbDropdownItem
                                        (click)="onEditConsumer(row)">
                                        {{
                                            'actions_editResident'
                                                | translate: 'online' : 'residents'
                                        }}
                                    </button>
                                    @if (row.canInvite) {
                                        <button
                                            type="button"
                                            ngbDropdownItem
                                            [disabled]="inviteInFlight()"
                                            (click)="onInviteConsumer(row)">
                                            {{
                                                row.inviteLabelKey
                                                    | translate: 'online' : 'residents'
                                            }}
                                        </button>
                                    }
                                    @if (row.canToggleHistory) {
                                        <button
                                            type="button"
                                            ngbDropdownItem
                                            (click)="onToggleHistory(row)">
                                            {{
                                                row.historyLabelKey
                                                    | translate: 'online' : 'residents'
                                            }}
                                        </button>
                                    }
                                </div>
                            </div>
                        }
                    </td>
                </tr>
            }
            @if (preparedRows().length === 0) {
                <tr>
                    <td [attr.colspan]="columnCount()" class="text-center">
                        {{ 'table_noResults' | translate: 'online' : 'common' }}
                    </td>
                </tr>
            }
        </tbody>
    </table>
</div>
